// extracted by mini-css-extract-plugin
module.exports = {"createButton":"CreatePage_createButton__1s4O1","closeButton":"CreatePage_closeButton__1VQng"};